import { RootState } from "store/store";

export const bulkResizeSelector = (state: RootState) => state.bulkResize;
